/* Native interactions for imported pages. Store/CRM submissions use their own forms. */
(() => {
  const normalize = value => String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[‐‑–—-]/g,' ').replace(/\s+/g,' ').trim();
  function setupCoverage() {
    const input=document.querySelector('[data-vtp-coverage-search]');
    const grid=document.querySelector('[data-vtp-brands]');
    if(!input||!grid)return;
    const status=document.querySelector('[data-vtp-coverage-status]');
    const request=document.querySelector('[data-vtp-request-model]');
    const brands=[...grid.querySelectorAll('[data-vtp-brand]')];
    brands.forEach(brand=>{
      const count=brand.querySelectorAll('li').length;
      brand.querySelector('[data-vtp-brand-count]').textContent=`${count} ${count===1?'model':'models'}`;
    });
    if(input.vtpGrid===grid)return;
    input.vtpAbort?.abort();
    input.vtpGrid=grid;input.vtpAbort=new AbortController();
    const filter=()=>{
      const query=normalize(input.value);let matched=0;
      brands.forEach(brand=>{
        const make=normalize(brand.querySelector('strong').textContent);
        const models=[...brand.querySelectorAll('li')].map(model=>normalize(model.textContent));
        const words=query.split(' ').filter(Boolean);
        const matches=!query||words.every(word=>make.includes(word))||models.some(model=>words.every(word=>(make+' '+model).includes(word)));
        brand.hidden=!matches;
        if(matches)matched++;
        if(query&&matches)brand.open=true;
      });
      status.hidden=!query;
      status.textContent=matched?`${matched} matching ${matched===1?'brand':'brands'} on the supported list. Expand a brand to check the exact model and version.`:'Not on the list yet. Contact us to check this model.';
      request.hidden=!query||matched>0;
    };
    input.addEventListener('input',filter,{signal:input.vtpAbort.signal});filter();
  }
  function init(){setupCoverage();}
  document.addEventListener('click',event=>{
    const thumb=event.target.closest('[data-vtp-gallery-thumb]');
    if(!thumb)return;
    const gallery=thumb.closest('.vtp-product-gallery');
    const image=gallery?.querySelector('[data-vtp-gallery-main] img');
    if(!image)return;
    event.preventDefault();image.src=thumb.href;image.removeAttribute('srcset');
    image.alt=thumb.querySelector('img')?.alt||'';
    gallery.querySelectorAll('[data-vtp-gallery-thumb]').forEach(link=>link.setAttribute('aria-current',String(link===thumb)));
  });
  document.addEventListener('change',event=>{
    if(!event.target.matches('[data-vtp-variant-picker]'))return;
    const url=new URL(location.href);url.searchParams.set('variant',event.target.value);
    location.assign(url.href);
  });
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:block:select',event=>{
    const brand=event.target.closest('.vtp-brand');
    if(brand)brand.open=true;
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
